// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ab-0";
export var orangeButton = "_ab-1";